import React from 'react'
import flus from './../assets/Flus.svg';
const Features = () => {
  return (
    <div className='features-container w-4/5 m-auto py-40'>
        <div className='text-center'>
            <h1 className='text-4xl font-bold text-[#1e1e1e]'>Our Features</h1>
            <p className='text-xl pt-10 pb-10 text-[#3f3f3f]'>From they fine john he give of rich he. They age and draw mrs like.Improving end<br/>distrusts may instantly was household applauded incommode</p>
        </div>
        <div className='flex box-container items-center'>
            <div className='bg-[#ffffff] drop-shadow-2xl features-box m-5 p-5'>
                <div className='flex p-3'>
                    <img src={flus} alt='' />
                    <p className='pl-3 text-[#52BD95] text-lg leading-6'>Easy Setup</p>
                </div>
                <p className='ml-10 text-[#3F3F3F] text-lg leading-7'>From they fine john he give of rich he.They age and draw
                mrs like.Improving end distrusts may instantly was
                household applauded incommode.Why kept very ever
                home mrs.
                </p>
            </div>
            <div className='bg-[#ffffff] drop-shadow-2xl features-box m-5 p-5'>
                <div className='flex p-3'>
                    <img src={flus} alt='' />
                    <p className='pl-3 text-[#52BD95] text-lg leading-6'>Easy Setup</p>
                </div>
                <p className='ml-10 text-[#3F3F3F] text-lg leading-7'>From they fine john he give of rich he.They age and draw
                mrs like.Improving end distrusts may instantly was
                household applauded incommode.Why kept very ever
                home mrs.
                </p>
            </div>

            <div className='bg-[#ffffff] drop-shadow-2xl features-box m-5 p-5'>
                <div className='flex p-3'>
                    <img src={flus} alt='' />
                    <p className='pl-3 text-[#52BD95] text-lg leading-6'>Easy Setup</p>
                </div>
                <p className='ml-10 text-[#3F3F3F] text-lg leading-7'>From they fine john he give of rich he.They age and draw
                mrs like.Improving end distrusts may instantly was
                household applauded incommode.Why kept very ever
                home mrs.
                </p>
            </div>
        </div>
        <div className='flex box-container'>
        <div className='bg-[#ffffff] drop-shadow-2xl features-box m-5 p-5'>
                <div className='flex p-3'>
                    <img src={flus} alt='' />
                    <p className='pl-3 text-[#52BD95] text-lg leading-6'>Easy Setup</p>
                </div>
                <p className='ml-10 text-[#3F3F3F] text-lg leading-7'>From they fine john he give of rich he.They age and draw
                mrs like.Improving end distrusts may instantly was
                household applauded incommode.Why kept very ever
                home mrs.
                </p>
            </div>
            <div className='bg-[#ffffff] drop-shadow-2xl features-box m-5 p-5'>
                <div className='flex p-3'>
                    <img src={flus} alt='' />
                    <p className='pl-3 text-[#52BD95] text-lg leading-6'>Easy Setup</p>
                </div>
                <p className='ml-10 text-[#3F3F3F] text-lg leading-7'>From they fine john he give of rich he.They age and draw
                mrs like.Improving end distrusts may instantly was
                household applauded incommode.Why kept very ever
                home mrs.
                </p>
            </div>
            <div className='bg-[#ffffff] drop-shadow-2xl features-box m-5 p-5'>
                <div className='flex p-3'>
                    <img src={flus} alt='' />
                    <p className='pl-3 text-[#52BD95] text-lg leading-6'>Easy Setup</p>
                </div>
                <p className='ml-10 text-[#3F3F3F] text-lg leading-7'>From they fine john he give of rich he.They age and draw
                mrs like.Improving end distrusts may instantly was
                household applauded incommode.Why kept very ever
                home mrs.
                </p>
            </div>
        </div>
    </div>
  )
}

export default Features